import React, { useEffect, useState, memo, useMemo } from "react";
import { Col, Row, Container, Image, Button, Alert, Spinner } from "react-bootstrap";
import { BrowserRouter as Router, Route, Switch, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import black_logo from "../assets/ModalX_-orange_Icon.png";
import white_logo from "../assets/modalX_robot_icon_white.png";
import MDEditor from '@uiw/react-md-editor';
import shareAPI from '../api/share.api';
import MessageActions from "../components/workspace/message/MessageActions";

// Memoized message component for better performance
const MessageComponent = memo(({ message, index, theme, decodeContent, renderResponse }) => {
  const isUserMessage = message.role === 'user' ? message.content : null;
  const isAssistantMessage = message.role === 'assistant' ? message.content : null;

    const handleDownload = (link) => {
    window.open(link, "_blank");
  };

  const handlePreview = (message) => {
   
  };

  return (
    <div key={index} style={{display:"flex", flexDirection:"column", gap:"15px"}}>
      {/* User Message */}
      {isUserMessage && (
        // <Row  className="justify-content-end" style={{ alignItems:"end",  border:"1px solid red"}}>
        //   <Col xs={12} className="text-end" style={{ marginBottom: '20px', paddingRight: '30px',paddingLeft:'30px'}}>
        //     <Row>
        //       <Col style={{ margin: 'auto', display : 'flex', flexDirection:"column",marginRight : '20px', justifyContent : 'end'}}>
        //         {typeof isUserMessage === 'string' && isUserMessage.split("\n").map((line, lineIndex) => (
        //           <div key={lineIndex} style={{ wordBreak: "break-word", textAlign : 'start', marginRight : '-13px', maxWidth : '95%'}}>
        //             {decodeContent(line)}
        //           </div>
        //         ))}
        //       </Col>
        //       <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-1" 
        //            style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
        //         <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
        //       </Col>
        //     </Row>
        //   </Col>
        // </Row>
        <Row className="justify-content-end" style={{ alignItems: "flex-end" }}>
  <Col
    xs={12}
    className="text-end"
    style={{
      marginBottom: "20px",
      paddingRight: "30px",
      paddingLeft: "30px",
    }}
  >
    <Row className="align-items-end justify-content-end">
      {/* Text Content */}
      <Col
        xs="auto"
        style={{
          margin: "0 15px 0 0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        {typeof isUserMessage === "string" &&
          isUserMessage.split("\n").map((line, lineIndex) => (
            <div
              key={lineIndex}
              style={{
                wordBreak: "break-word",
                textAlign: "start",
                borderRadius: "12px",
                padding: "10px 14px",
              }}
            >
              {decodeContent(line)}
            </div>
          ))}
      </Col>

      {/* User Icon / Image */}
      <Col
        xs="auto"
        className="d-flex align-items-end justify-content-end p-0"
        style={{
          width: "48px",
          height: "48px",
        }}
      >
        <div
          style={{
            backgroundColor: "#1F233E",
            borderRadius: "50%",
            width: "48px",
            height: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Replace <i> with image if available */}
          {/* Example: <img src={userImage} alt="User" style={{ width: "100%", height: "100%", borderRadius: "50%" }} /> */}
          <i className="bi bi-person fs-4 text-white" />
        </div>
      </Col>
    </Row>
  </Col>
</Row>

      )}

      {/* Assistant Message */}
      {isAssistantMessage && (
        <Row className="justify-content-end">
         {
           message?.asset_generation?.assets?.length > 0 ?
          <Row style={{columnGap:"20px"}}>
            <Col style={{width: '48px', height: '48px', backgroundColor : '#1F233E', marginRight : '', marginLeft : '7px', borderRadius : '24px'}} xs={1}>
                <img style={{ width: '24px', height: '24px' , marginTop : '12px'}} 
                     src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
              </Col>
            <Col className="text-end" style={{ 
                        maxWidth : '800px',
                        width:"100%",
                        display: message?.asset_generation?.asset_counts?.image ? 'flex' : '', 
                        flexWrap: message?.asset_generation?.asset_counts?.image ? 'wrap' :'', 
                        // justifyContent: imagePreview ?'space-evenly' :'', 
                        // flexBasis: imagePreview ?  'calc(50% - 10px)' : '', /* Each item takes 50% of the row minus some gap */ 
                        gap: "10px", /* Optional: adds space between items */
                        margin:"0px 0px",
                        padding:"0px 0px",
                        alignItems:"end"
                      }}>
                            <MessageActions
                              message={message}
                              handleDownload={handleDownload}
                              handlePreview={handlePreview}
                            /> 
                      </Col>
            </Row>
            :
          <Col xs={11} className="text-end" style={{ marginBottom: '40px'}}>
            <Row style={{ marginLeft : '-86px'}}>
              <Col style={{width: '48px', height: '48px', backgroundColor : '#1F233E', marginRight : '', marginLeft : '7px', borderRadius : '24px'}} xs={1}>
                <img style={{ width: '24px', height: '24px' , marginTop : '12px'}} 
                     src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
              </Col>
              <Col xs={11} style={{ margin: 'auto',paddingTop:'10px', marginLeft : '10px', width : '90%'}} 
                   className="text-start">
                <Row>
                  {typeof isAssistantMessage === 'string' && renderResponse(isAssistantMessage)}
                </Row>
              </Col>
            </Row>
          </Col>
         }
        </Row>
      )}
    </div>
  );
});

const ShareProject = () => {
    const [shareData, setShareData] = useState(null);
    const [sessionData, setSessionData] = useState(null);
    const [allMessages, setAllMessages] = useState([]);
    const [displayedMessages, setDisplayedMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [theme, setTheme] = useState(localStorage.getItem('theme'));
    const [renderingMessages, setRenderingMessages] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [useMarkdownRenderer, setUseMarkdownRenderer] = useState(false);
    const { token } = useParams();
    const navigate = useNavigate();

    // Simple constants
    const INITIAL_BATCH_SIZE = 5; // Show first 5 messages
    const LARGE_CONVERSATION_THRESHOLD = 10; // Consider 10+ messages as large

    // Function to load all remaining messages
    const loadAllRemainingMessages = () => {
        if (!loadingMore && allMessages.length > displayedMessages.length) {
            setLoadingMore(true);
            // Load ALL remaining messages at once
            setDisplayedMessages(allMessages);
            setLoadingMore(false);
        }
    };

    // Function to fetch shared session data
    const fetchSharedSessionData = async (token) => {
        console.log('Fetching shared session with token:', token);
        setLoading(true);
        setError(null);

        try {
            const response = await shareAPI.getSharedSessionData(token);
            console.log('Shared session data:', response);
            
            if (response.status || response.success) {
                setShareData(response.data.shared_session);
                setSessionData(response.data.session_data);
                
                const messageData = response.data.messages || [];
                console.log(`Loading ${messageData.length} messages...`);
                setAllMessages(messageData);
                
                // Always load all messages directly
                setDisplayedMessages(messageData);
            } else {
                setError('Failed to load shared session');
                setTimeout(() => navigate('/'), 3000);
            }
        } catch (err) {
            console.error('Error fetching shared session:', err);
            if (err.response?.status === 404) {
                setError('This shared session could not be found or has expired.');
            } else if (err.response?.status === 403) {
                setError('This shared session is no longer active.');
            } else {
                setError('Failed to load shared session. Please check the link and try again.');
            }
            setTimeout(() => navigate('/'), 5000);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {  
        setTheme(localStorage.getItem('theme'));
        if (token) {
            fetchSharedSessionData(token); 
        }
    }, [token]);

      const findUrl = (msg) => {
        const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
        const match = urlRegex.exec(msg);
        return match ? match[1] : null;
      };

      const removeUrlsAndBrackets = (msg) => {
        return msg.replace(/\(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt)\)/g, '');
      };
    
    const decodeUnicode = (str) => {
        // const stringWithoutDoubleBackslashes = str.split("\\\")
        const stringNewLine = str.split("\\n").join("\n")
        let stringNewLineWithAnchorTag = stringNewLine.replace(/\\u[\dA-F]{4}|u[\dA-F]{4}/gi, (match) => {
          const hexCode = match.replace(/\\?u/g, ''); // Remove '\u' or 'u'
          return String.fromCharCode(parseInt(hexCode, 16)); // Convert hex code to character
        });
        const finalString = stringNewLineWithAnchorTag.replace(/\\/g, '');
        return finalString
      };
    
    // Function to decode HTML entities
    const decodeContent = (content) => {
      return decodeUnicode((content));
    };

    const getFileFormat = (url) => {
        // Extract the file extension from the URL
        const parts = url.split('.');
        if (parts.length > 1) {
          return parts[parts.length - 1]; // Return the last part as the file format
        } else {
          return ''; // Return empty string if no file extension found
        }
      };

    // Ultra-fast plain text renderer (no processing)
    const renderResponseUltraFast = useMemo(() => {
      return (response) => {
        // Minimal processing - just display as-is
        return (
          <div style={{ 
            wordBreak: "break-word", 
            whiteSpace: "pre-wrap", 
            fontFamily: "inherit",
            padding: "10px",
            // backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            margin: "5px 0"
          }}>
            {response}
          </div>
        );
      };
    }, []);

    // Fast plain text renderer for initial load
    const renderResponseFast = useMemo(() => {
      return (response) => {
        const decoded = decodeUnicode(response);
        // Simple text rendering with basic formatting
        return (
          <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
            {decoded.split('\n').map((line, index) => (
              <div key={index} style={{ marginBottom: line.trim() === '' ? '10px' : '2px' }}>
                {line || '\u00A0'} {/* Non-breaking space for empty lines */}
              </div>
            ))}
          </div>
        );
      };
    }, []);

    // Heavy markdown renderer (kept for future enhancement)
    const renderResponseMarkdown = useMemo(() => {
      return (response) => (
              // console.log("response",response)
        <div style={{ wordBreak: "break-word" }}>
          <MDEditor.Markdown 
            source={decodeUnicode(response)} 
            style={{ backgroundColor:"#171A2D", color:"white"}}  
            className="custom-md-editor"
          />
        </div>
      );
    }, []);

    // Use ultra-fast renderer by default, with options for better formatting
    const renderResponse = useMarkdownRenderer ? renderResponseMarkdown : renderResponseUltraFast;

  // Loading state
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" className="mb-3" />
          <p>Loading shared conversation...</p>
          <small className="text-muted">This may take a moment for conversations with many messages</small>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <Container className="mt-5">
        <div className="text-center">
          <Alert variant="danger">
            <Alert.Heading>Unable to Load Shared Session</Alert.Heading>
            <p>{error}</p>
            <hr />
            <p className="mb-0">
              You will be redirected to the homepage shortly, or{' '}
              <Button variant="link" onClick={() => navigate('/')}>click here</Button> to go now.
            </p>
          </Alert>
        </div>
      </Container>
    );
  }

  return (
    <> 
      {/* Header with session info */}
      {shareData && (
        <Container className="mt-4 mb-4">
          <div className="text-center border-bottom pb-3">
            <h2>{shareData.title?.valid ? shareData.title.string : 'Shared Conversation'}</h2>
            {shareData.description?.valid && (
              <p className="text-muted">{shareData.description.string}</p>
            )}
            <div className="d-flex justify-content-center gap-3">
              <small className="text-muted">
                Shared on {new Date(shareData.created_at).toLocaleDateString()}
                {shareData.access_count > 0 && ` • Viewed ${shareData.access_count} times`}
              </small>
              {allMessages.length > 0 && (
                <small className="text-primary">
                  {allMessages.length} messages
                </small>
              )}
            </div>
          </div>
        </Container>
      )}

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ maxWidth: "90%", padding: "50px 100px" }}>
          {renderingMessages ? (
            <div className="text-center">
              <Spinner animation="border" variant="secondary" size="sm" className="mb-2" />
              <p className="text-muted">Rendering messages...</p>
              {allMessages.length > LARGE_CONVERSATION_THRESHOLD && (
                <small className="text-muted">Loading {INITIAL_BATCH_SIZE} of {allMessages.length} messages first for faster display</small>
              )}
            </div>
          ) : displayedMessages && displayedMessages.length > 0 ? (
            <>
              {displayedMessages.map((message, index) => (
                <MessageComponent
                  key={`message-${message.id || index}`}
                  message={message}
                  index={index}
                  theme={theme}
                  decodeContent={decodeContent}
                  renderResponse={renderResponse}
                />
              ))}
              
              {/* Rich Formatting Toggle */}
              <div className="text-center mt-4 mb-4">
                <Button 
                  variant={useMarkdownRenderer ? "success" : "outline-secondary"}
                  size="sm"
                  onClick={() => setUseMarkdownRenderer(!useMarkdownRenderer)}
                >
                  {useMarkdownRenderer ? "✓ Rich Formatting" : "Enable Rich Formatting"}
                </Button>
                <div>
                  <small className="text-muted">
                    {useMarkdownRenderer 
                      ? "Rich formatting enabled" 
                      : "Click to enable rich formatting (tables, markdown, etc.)"
                    }
                  </small>
                </div>
              </div>
            </>
          ) : (
            <div className="text-center text-muted">
              <p>No messages found in this shared session.</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default ShareProject